import { useState } from 'react';

export const useShow = (initial = false) => {
    const [isShown, setShown] = useState<boolean>(initial);

    return {
        isShown,
        set: setShown,
        reset: () => setShown(initial),
        toggle: () => setShown(prev => !prev),
    };
};
